import type { ComponentPublicInstance } from 'vue';

export function scrollToFirstInvalid(
  formRef: ComponentPublicInstance | HTMLElement,
  vuetify = null,
  offset = 100
) {
  if (!formRef) return;
  // prefer the component element if available
  const el: HTMLElement | null =
    ((formRef as ComponentPublicInstance).$el as HTMLElement) || (formRef as HTMLElement);
  if (!el) return;

  // Find any visible validation message created by Vuetify
  const messages = Array.from(el.querySelectorAll('.v-messages__message')) as HTMLElement[];
  let target: HTMLElement | null = null;

  for (const msg of messages) {
    if (msg && msg.textContent && msg.textContent.trim().length > 0) {
      target = (msg.closest('.v-input') as HTMLElement) || (msg.parentElement as HTMLElement);
      break;
    }
  }

  // fallback: look for any element which the browser marks invalid
  if (!target) {
    const invalidEl = el.querySelector(
      'input:invalid, select:invalid, textarea:invalid'
    ) as HTMLElement | null;
    if (invalidEl) target = invalidEl;
  }

  if (!target) return;

  if (vuetify && typeof vuetify.goTo === 'function') {
    vuetify.goTo(target, { offset });
  } else {
    const y = target.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
    try {
      (target as HTMLElement).focus();
    } catch {
      // ignore
    }
  }
}

export default scrollToFirstInvalid;
